import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TagPillPurpose } from './tag-pill-purpose';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
function TagPillComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 3);
} }
const _c0 = ["*"];
export class TagPillComponent {
    constructor() {
        this.tagPillText = '';
        this.disabled = false;
        this.selected = false;
        this.purpose = TagPillPurpose.Secondary;
        this.ariaExpanded = null;
    }
}
TagPillComponent.ɵfac = function TagPillComponent_Factory(t) { return new (t || TagPillComponent)(); };
TagPillComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TagPillComponent, selectors: [["mhe-tag-pill"]], inputs: { tagPillText: "tagPillText", disabled: "disabled", selected: "selected", purpose: "purpose", ariaExpanded: "ariaExpanded" }, ngContentSelectors: _c0, decls: 5, vars: 7, consts: [[3, "disabled"], ["button", ""], ["class", "dpg-icon dpg-icon-confirmation-white tick-icon", 4, "ngIf"], [1, "dpg-icon", "dpg-icon-confirmation-white", "tick-icon"]], template: function TagPillComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "button", 0, 1);
        i0.ɵɵtemplate(2, TagPillComponent_i_2_Template, 1, 0, "i", 2);
        i0.ɵɵtext(3);
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("btn ", ctx.purpose, " pill-btn");
        i0.ɵɵproperty("disabled", ctx.disabled);
        i0.ɵɵattribute("aria-expanded", ctx.ariaExpanded);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selected);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.tagPillText, " ");
    } }, dependencies: [i1.NgIf], styles: [".pill-btn[_ngcontent-%COMP%]{border-radius:20px;padding:0 10px;height:30px;display:flex;align-items:center}.pill-btn.btn-secondary[_ngcontent-%COMP%]:not([disabled]):active:before, .pill-btn.btn-secondary[_ngcontent-%COMP%]:not([disabled]):focus.active:before, .pill-btn.btn-secondary[_ngcontent-%COMP%]:not([disabled]):focus:before, .pill-btn.btn-primary[_ngcontent-%COMP%]:not([disabled]):active:before, .pill-btn.btn-primary[_ngcontent-%COMP%]:not([disabled]):focus.active:before, .pill-btn.btn-primary[_ngcontent-%COMP%]:not([disabled]):focus:before{border-radius:20px}.tick-icon[_ngcontent-%COMP%]{position:relative;right:5px}\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagPillComponent, [{
        type: Component,
        args: [{ selector: 'mhe-tag-pill', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button #button class=\"btn {{ purpose }} pill-btn\" [disabled]=\"disabled\" [attr.aria-expanded]=\"ariaExpanded\">\n  <i *ngIf=\"selected\" class=\"dpg-icon dpg-icon-confirmation-white tick-icon\"></i>\n  {{ tagPillText }}\n  <ng-content></ng-content>\n</button>\n", styles: [".pill-btn{border-radius:20px;padding:0 10px;height:30px;display:flex;align-items:center}.pill-btn.btn-secondary:not([disabled]):active:before,.pill-btn.btn-secondary:not([disabled]):focus.active:before,.pill-btn.btn-secondary:not([disabled]):focus:before,.pill-btn.btn-primary:not([disabled]):active:before,.pill-btn.btn-primary:not([disabled]):focus.active:before,.pill-btn.btn-primary:not([disabled]):focus:before{border-radius:20px}.tick-icon{position:relative;right:5px}/*# sourceMappingURL=tag-pill.component.css.map */\n"] }]
    }], null, { tagPillText: [{
            type: Input
        }], disabled: [{
            type: Input
        }], selected: [{
            type: Input
        }], purpose: [{
            type: Input
        }], ariaExpanded: [{
            type: Input
        }] }); })();
